module.exports = __webpack_public_path__ + "img/world_vision_icon1.fa73c608.svg";